import { render } from "./SweetLoader.vue?vue&type=template&id=3a5ddc4d&scoped=true"
import script from "./SweetLoader.vue?vue&type=script&lang=js"
export * from "./SweetLoader.vue?vue&type=script&lang=js"

import "./SweetLoader.vue?vue&type=style&index=0&id=3a5ddc4d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5ddc4d"]])

export default __exports__